import Vue from "vue";
import Vuex from "vuex";

import persistedState from "vuex-persistedstate";
import authStore from "./modules/auth";
import complexes from "./modules/complexes";
import menus from "./modules/menus";
import aptLogs from "./modules/apt-logs";

Vue.use(Vuex);

const initialState = () => ({
  token: "",
  errors: null,
  user: {},
});

export const store = new Vuex.Store({
  plugins: [
    persistedState({
      reducer: (state) => ({
        ...state,
        aptLogs: undefined,
      }),
    }),
  ],
  modules: {
    authStore,
    complexes,
    menus,
    aptLogs,
  },
  mutations: {
    reset(state) {
      const initial = initialState();
      Object.assign(state.authStore, initial);
    },
    setToken(state, token) {
      authStore.token = token;
    },
  },
  actions: {
    logout(context) {
      context.commit("reset");
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js